var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"divera247-spa",class:{ 'app--dragover': _vm.draggingEnterCounter > 0 }},[_c('the-navigation',{attrs:{"hide":_vm.isDashboardRoute}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }